// extracted by mini-css-extract-plugin
export default {"PopularTeamsTable":"Show-module__PopularTeamsTable__gdOef"};